import { gql } from '@apollo/client';

export const CHECK_ACCOUNT_BY_PHONE = gql`
    query CheckAccountByPhone($phoneNumber: String!) {
        checkAccountByPhone(phoneNumber: $phoneNumber) {
            exists
            role
        }
    }
`;

export interface CheckAccountByPhoneResult {
    exists: boolean;
    role: string | null;
}

export interface CheckAccountByPhoneResponse {
    checkAccountByPhone: CheckAccountByPhoneResult;
}
